export { default as FarmIcon } from "./Farm";
export { default as GroupsIcon } from "./Groups";
export { default as HamburgerIcon } from "./Hamburger";
export { default as HamburgerCloseIcon } from "./HamburgerClose";
export { default as HomeIcon } from "./Home";
export { default as IfoIcon } from "./Ifo";
export { default as InfoIcon } from "./Info";
export { default as LanguageIcon } from "./Language";
export { default as LogoIcon } from "./Logo";
export { default as MoonIcon } from "./Moon";
export { default as MoreIcon } from "./More";
export { default as NftIcon } from "./Nft";
export { default as PoolIcon } from "./Pool";
export { default as SunIcon } from "./Sun";
export { default as TelegramIcon } from "./Telegram";
export { default as TicketIcon } from "./Ticket";
export { default as TradeIcon } from "./Trade";
export { default as TwitterIcon } from "./Twitter";
export { default as MediumIcon } from "../../Svg/Icons/Medium";
export { default as DiscordIcon } from "../../Svg/Icons/Discord";
